import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { useUpdatePushScenario } from '~entities/mobile-inventor-push/api/update-push-scenario';
import type { PushScenarioToggle } from '~entities/mobile-inventor-push/model/types';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Switch } from '~shared/shadcn/ui/switch';

interface PushScenarioToggleCardProps {
  toggle: PushScenarioToggle;
}

export const PushScenarioToggleCard = ({ toggle }: PushScenarioToggleCardProps) => {
  const { mutateAsync: updateScenario, isPending } = useUpdatePushScenario();

  const handleToggleChange = async (checked: boolean) => {
    try {
      await updateScenario({ name: toggle.name, enabled: checked });
      toast.success(
        `${toggle.description} ${checked ? 'enabled' : 'disabled'}`,
      );
    } catch {
      // Error toast handled in mutation hook.
    }
  };

  return (
    <Card className='w-full'>
      <CardHeader className='pb-2'>
        <div className='flex items-center justify-between gap-3'>
          <CardTitle className='text-base'>{toggle.name.replace(/_/g, ' ')}</CardTitle>
          <div className='relative'>
            {isPending ? (
              <Loader2 className='absolute -left-7 top-0 size-4 animate-spin' />
            ) : null}
            <Switch
              checked={toggle.enabled}
              onCheckedChange={(checked) => void handleToggleChange(checked)}
              disabled={isPending}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription>{toggle.description}</CardDescription>
      </CardContent>
    </Card>
  );
};
